module.exports = __webpack_public_path__ + "static/media/c200-title-banner.6634745a.jpg";